const dev = {
  apiUrl: 'http://localhost:8080',
};

const prod = {
  apiUrl: '',
};

const configs = process.env.REACT_APP_STAGE === 'production' ? prod : dev;

// eslint-disable-next-line import/no-anonymous-default-export
// export default {
//   // Add common config values here
//   MAX_ATTACHMENT_SIZE: 5000000,
//   ...configs,
// };

export const config = {
  MAX_ATTACHMENT_SIZE: 5000000,
  S3Url: '',
  // 기본 창고 UUID (향후 다중 창고 지원 시 API에서 동적으로 가져오도록 변경)
  DEFAULT_WH_UUID: '432674D4-C8D8-4F1F-B3EC-84FE401380A0',
  ...configs,
};
